import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

interface StyleProps {
  isAvailableNow?: boolean;
}

interface SingleVehicleImageProps {
  isNewVehicle: boolean;
  isReservedVehicle?: boolean;
}

export const Result = styled.li`
  display: block;
  font-family: 'Audi Type';
  width: 424px;
  min-width: 339px;
  background: ${COLORS.white};
  margin: ${SIZING.unit(0.75)} ${SIZING.unit(1)};
  @media ${device.tablet} {
    width: 424px;
    margin: ${SIZING.unit(1.5)};
    &:hover,
    &:active {
      box-shadow: 0 9px 18px ${COLORS.grey20};
    }
  }
`;

export const Button = styled.a<{
  isReservedVehicle?: boolean;
  noPadding?: boolean;
  relative?: boolean;
  noCursor?: boolean;
}>`
  text-decoration: none;
  border: none;
  text-align: left;
  background: ${({ isReservedVehicle }) => (isReservedVehicle ? 'inherit' : COLORS.white)};
  border: ${({ isReservedVehicle }) => isReservedVehicle && `1px solid ${COLORS.grey30}`};
  padding: 0;
  width: 100%;
  height: 100%;
  padding: 0 ${({ noPadding }) => (noPadding ? '0' : SIZING.unit(3))};
  font-family: 'Audi Type';
  cursor: ${({ noCursor }) => (noCursor ? 'initial' : 'pointer')};
  &:focus {
    outline: 2px solid ${COLORS.black};
  }
  :focus:not(:focus-visible) {
    outline: none;
    outline-offset: 0;
  }
  position: ${({ relative }) => relative && `relative`};
`;

export const InfoIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  margin-left: ${SIZING.unit(1)};
  // margin-right: ${SIZING.unit(1.25)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .popover-styles {
    background-color: ${COLORS.grey80};
    width: 200px;
    margin-top: ${SIZING.unit(0.5)};
    @media ${device.tablet} {
      width: 250px;
    }
    @media ${device.laptop} {
      width: 300px;
    }
    polygon {
      fill: ${COLORS.grey80};
    }
  }
`;

export const StyledInfoButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const VehicleCard = styled.li<{ noHoverEffect?: boolean; isReservedVehicle?: boolean }>`
  /* display: block; */
  /* position: relative; */
  font-family: 'Audi Type';
  width: 357px;
  min-width: 339px;
  // height: 559px;
  border: ${({ isReservedVehicle }) => isReservedVehicle && `1px solid ${COLORS.grey30}`};
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${device.tablet} {
    width: 424px;
    &:hover,
    &:active {
      ${({ noHoverEffect }) => {
        if (noHoverEffect) return css``;
        return css`
          box-shadow: 0 9px 18px ${COLORS.grey20};
          #status {
            color: ${COLORS.black};
          }
          #infoIcon {
            stroke: ${COLORS.black};
          }
        `;
      }}
    }
  }
`;

export const StatusContainer = styled.div`
  margin-bottom: ${SIZING.unit(2)};
`;

export const StatusWrapper = styled.div`
  width: 100%;
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
`;

export const StatusTitle = styled.div``;

export const VehicleInfo = styled.div`
  padding-top: ${SIZING.unit(4)};
`;

export const VehicleName = styled.div`
  margin-bottom: ${SIZING.unit(1.5)};
  min-height: 24px;
  max-height: 48px;
  color: ${COLORS.black};
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
`;

export const VehicleTrim = styled.div`
  margin-bottom: ${SIZING.unit(2)};
  height: 20px;
  color: ${COLORS.grey80};
  font-size: 13px;
  line-height: 20px;
`;

export const LocationWrapper = styled.div<{ isNewVehicle: boolean; noFixHeight: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: ${SIZING.unit(2)};
  ${({ isNewVehicle, noFixHeight }) => {
    if (noFixHeight) return css``;
    if (isNewVehicle)
      return css`
        height: 60px;
      `;
    return css`
      height: 38px;
    `;
  }}
`;

export const LocationText = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 20px;
`;

export const DistanceFromUser = styled.div`
  color: ${COLORS.grey70};
  font-size: 13px;
  margin-left: ${SIZING.unit(0.5)};
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const IconContainer = styled.span`
  display: inline-block;
  margin-right: ${SIZING.unit(0.5)};
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 24px;
  svg {
    max-width: 100%;
    width: 100%;
  }
`;

export const LegalCTA = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: ${SIZING.unit(1)};
  &:focus {
    outline: 2px solid ${COLORS.black};
    outline-offset: 2px;
  }
  :focus:not(:focus-visible) {
    outline: none;
    outline-offset: 0;
  }
`;

export const CpoBLOCK = styled.div<{ isCPO: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: ${({ isCPO }) => (isCPO ? 'space-between' : 'flex-end')};
  margin-bottom: ${SIZING.unit(2)};
`;

export const CpoIcon = styled.div``;

export const Milage = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
  padding-bottom: 6px;
`;

export const ImageBlock = styled.div``;

export const ImageContainer = styled.div<{ noPadding?: boolean }>`
  padding: ${({ noPadding }) => (noPadding ? '0' : SIZING.unit(1))} 0;
  height: 211px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: block;
`;

export const VehicleImageWrapper = styled.img`
  object-fit: contain;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 100%;
`;

export const SingleVehicleImage = styled.img<SingleVehicleImageProps>`
  width: 100%;
  object-fit: contain;
  height: 100%;
  scale: ${({ isNewVehicle }) => isNewVehicle && '1.12'};
  opacity: ${({ isReservedVehicle }) => isReservedVehicle && '0.5'};
  display: block;
`;

export const PriceBlock = styled.div`
  height: 116px;
  padding-bottom: ${SIZING.unit(4)};
  padding-top: ${SIZING.unit(4)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const DoublePrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const DealerPriceBlock = styled.div<{ isDoublePrice: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isDoublePrice }) => (isDoublePrice ? 'flex-start' : 'center')};
  justify-content: center;
  gap: 8px;
`;

export const MSRPBlock = styled.div<{ isDoublePrice: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isDoublePrice }) => (isDoublePrice ? 'flex-start' : 'center')};
  gap: 8px;
`;

export const PriceTitle = styled.div`
  font-size: 13px;
  line-height: 20px;
  color: ${COLORS.grey80};
`;

export const DealerPrice = styled.div`
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  color: ${COLORS.black};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const MSRPPrice = styled.div<{ mainPrice: boolean }>`
  font-size: ${({ mainPrice }) => (mainPrice ? '16px' : '20px')};
  line-height: 24px;
  font-weight: ${({ mainPrice }) => (mainPrice ? '400' : '700')};
  color: ${({ mainPrice }) => (mainPrice ? COLORS.grey60 : COLORS.black)};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Price = styled.div<{ mainPrice: boolean }>`
  font-size: ${({ mainPrice }) => (mainPrice ? '16px' : '20px')};
  line-height: 24px;
  font-weight: ${({ mainPrice }) => (mainPrice ? '400' : '700')};
  color: ${({ mainPrice }) => (mainPrice ? COLORS.grey60 : COLORS.black)};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ContactDealerText = styled.p`
  padding: ${SIZING.unit(1)} ${SIZING.unit(3)};
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  text-align: center;
  color: ${COLORS.black};
`;

export const DisclaimerIcon = styled.div``;

export const StatusDot = styled.div<{ statusForDot: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: ${SIZING.unit(1)};

  ${({ statusForDot }) => {
    if (statusForDot === 'RESERVED')
      return css`
        background: ${COLORS.redRibbon};
      `;
    if (statusForDot === 'AVAILABLE')
      return css`
        background: ${COLORS.spaceInvader};
      `;
    return css`
      background: ${COLORS.flashOfOrange};
    `;
  }}
`;

export const Legal = styled.div`
  padding: 0 16px 16px;

  @media ${device.tablet} {
    padding: 0 48px 48px;
  }
  @media ${device.tablet} {
    padding: 0 60px 60px;
  }
`;

export const TextContainer = styled.div`
  font-family: 'Audi Type';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
`;
